import {DeviceActions, DeviceActionTypes} from '../actions/device.actions';
import {Device} from '../models/device';
import {ErrorPayload} from '../models/general';

export interface State {
  entities: { [deviceUuid: string]: Device };
  isGetDevicesLoading: boolean;
  isGetDevicesLoaded: boolean;
  getDevicesError: string | null;
  isPostDeviceNamesLoading: boolean;
  isPostDeviceNamesLoaded: boolean;
  postDeviceNamesError: string | null;
  isPostShowDevicesLedLoading: boolean;
  isPostShowDevicesLedLoaded: boolean;
  postShowDevicesLedError: string | null;
  isPostHideDevicesLedLoading: boolean;
  isPostHideDevicesLedLoaded: boolean;
  postHideDevicesLedError: string | null;
}

export const initialState: State = {
  entities: {},
  isGetDevicesLoading: false,
  isGetDevicesLoaded: false,
  getDevicesError: null,
  isPostDeviceNamesLoading: false,
  isPostDeviceNamesLoaded: false,
  postDeviceNamesError: null,
  isPostShowDevicesLedLoading: false,
  isPostShowDevicesLedLoaded: false,
  postShowDevicesLedError: null,
  isPostHideDevicesLedLoading: false,
  isPostHideDevicesLedLoaded: false,
  postHideDevicesLedError: null
};

export function reducer(state = initialState, action: DeviceActions): State {
  switch (action.type) {

    case DeviceActionTypes.GetOrganizationDevices: {
      return {
        ...state,
        isGetDevicesLoading: true,
        isGetDevicesLoaded: false,
        getDevicesError: null
      };
    }
    case DeviceActionTypes.GetOrganizationDevicesComplete: {
      const devices: Device[] = action.payload;
      const newEntities = devices.reduce((entities: { [deviceUuid: string]: Device }, device: Device) => {
        return {...entities, [`${device.deviceType}_${device.deviceId}`]: device};
      }, {});

      return {
        ...state,
        entities: newEntities,
        isGetDevicesLoading: false,
        isGetDevicesLoaded: true,
      };
    }

    case DeviceActionTypes.GetOrganizationDevicesError: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        isGetDevicesLoading: false,
        getDevicesError: errorPayload.errorMessage
      }
    }

    case DeviceActionTypes.PostDeviceNames: {
      return {
        ...state,
        isPostDeviceNamesLoading: true,
        isPostDeviceNamesLoaded: false,
        postDeviceNamesError: null
      };
    }

    case DeviceActionTypes.PostDeviceNamesComplete: {
      return {
        ...state,
        isPostDeviceNamesLoading: false,
        isPostDeviceNamesLoaded: true
      };
    }

    case DeviceActionTypes.PostDeviceNamesError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isPostDeviceNamesLoading: false,
        postDeviceNamesError: errorPayload.errorMessage
      };
    }

    case DeviceActionTypes.PostShowDevicesLed: {
      return {
        ...state,
        isPostShowDevicesLedLoading: true,
        isPostShowDevicesLedLoaded: false,
        postShowDevicesLedError: null
      };
    }

    case DeviceActionTypes.PostShowDevicesLedComplete: {
      return {
        ...state,
        isPostShowDevicesLedLoading: false,
        isPostShowDevicesLedLoaded: true
      };
    }

    case DeviceActionTypes.PostShowDevicesLedError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isPostShowDevicesLedLoading: false,
        postShowDevicesLedError: errorPayload.errorMessage
      };
    }

    case DeviceActionTypes.PostHideDevicesLed: {
      return {
        ...state,
        isPostHideDevicesLedLoading: true,
        isPostHideDevicesLedLoaded: false,
        postHideDevicesLedError: null
      };
    }

    case DeviceActionTypes.PostHideDevicesLedComplete: {
      return {
        ...state,
        isPostHideDevicesLedLoading: false,
        isPostHideDevicesLedLoaded: true
      };
    }

    case DeviceActionTypes.PostHideDevicesLedError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isPostHideDevicesLedLoading: false,
        postHideDevicesLedError: errorPayload.errorMessage
      };
    }

    default:
      return state;
  }
}

export const deviceEntities = (state: State) => state.entities;
export const isGetDevicesLoading = (state: State) => state.isGetDevicesLoading;
export const isGetDevicesLoaded = (state: State) => state.isGetDevicesLoaded;
export const getDevicesError = (state: State) => state.getDevicesError;
export const isPostDeviceNamesLoading = (state: State) => state.isPostDeviceNamesLoading;
export const isPostDeviceNamesLoaded = (state: State) => state.isPostDeviceNamesLoaded;
export const postDeviceNamesError = (state: State) => state.postDeviceNamesError;
export const isPostShowDevicesLedLoading = (state: State) => state.isPostShowDevicesLedLoading;
export const isPostShowDevicesLedLoaded = (state: State) => state.isPostShowDevicesLedLoaded;
export const postShowDevicesLedError = (state: State) => state.postShowDevicesLedError;
export const isPostHideDevicesLedLoading = (state: State) => state.isPostHideDevicesLedLoading;
export const isPostHideDevicesLedLoaded = (state: State) => state.isPostHideDevicesLedLoaded;
export const postHideDevicesLedError = (state: State) => state.postHideDevicesLedError;
